export default "__VITE_ASSET__f42434a3__"